<template>
  <div id="dvCenyBox">
    <spodek></spodek>
    <tlacitkoAtd></tlacitkoAtd>
  </div>
</template>

<script>
import spodek from "./CenyBox/spodek.vue";
import tlacitkoAtd from "./CenyBox/tlacitkoAtd.vue";

export default {
  name: "CenyBox",
  components: {
    spodek,
    tlacitkoAtd
  }
};
</script>
<style lang="less"></style>
